import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { GpsBaseURL, uniqueToken } from "../../api/DataApis";

function EditCompany() {
  document.title = "Company | Edit";
  const navigate = useNavigate();
  const { id } = useParams(); // company ID from URL

  const [Title, setTitle] = useState("");

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  // Fetch existing company details
  const fetchCompanyDetails = async () => {
    try {
      const response = await axios.get(`${GpsBaseURL}/company/list/${id}`, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      if (response?.data?.statusCode === 200) {
        setTitle(response?.data?.data[0]?.company_name);
      } else {
        Swal.fire("Error", "Failed to fetch company details", "error");
      }
    } catch (error) {
      console.error("Fetch company error:", error);
      Swal.fire("Error", "Failed to load company", "error");
    }
  };

  // Update request
  const updateCompany = async () => {

    Swal.fire({
      title: 'Updating Company...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    let formData = new FormData();
    formData.append("company_name", Title);

    try {
      const response = await axios.put(
        `${GpsBaseURL}/company/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        }
      );

      Swal.close();

      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: response.data.message,
          timer: 1500,
          showConfirmButton: false,
        });
        navigate("/company-list");
      } else {
        Swal.fire("Error", response.data.message, "error");
      }
    } catch (error) {
      Swal.close();
      console.error("Error in updateCompany:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Unexpected error",
        "error"
      );
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Edit Company
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <button className="btn btn-success" onClick={() => navigate(-1)}>
                      Back
                    </button>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form className="form-horizontal" encType="multipart/form-data" method="post">
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                              Company Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="text"
                                onChange={(e) => setTitle(e.target.value)}
                                value={Title}
                                className="form-control"
                                id="name_id"
                                name="company_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-primary"
                              onClick={updateCompany}
                              value="Update Company"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditCompany;
